import React, { createContext, useContext, useMemo,useReducer } from 'react';

import { useSelector } from 'react-redux';

import { ACTIONS, initialState, scheduleListReducer } from '../reducer';

const ScheduleListContext = createContext();

export const ScheduleListProvider = ({ children }) => {
  const orgId = useSelector(({ organizations }) => organizations.organization.id);
  const [state, dispatch] = useReducer(scheduleListReducer, initialState);

  const setSelectedSchedule = payload => {
    dispatch({ type: ACTIONS.SET_SELECTED_SCHEDULE, payload });
  };

  const setInfoSchedule = payload => {
    dispatch({ type: ACTIONS.SET_INFO_SCHEDULE, payload });
  };

  const setMembers = payload => {
    dispatch({ type: ACTIONS.SET_MEMBERS, payload });
  };

  const setSupervisors = payload => {
    dispatch({ type: ACTIONS.SET_SUPERVISORS, payload });
  };

  const setSchedules = payload => {
    dispatch({ type: ACTIONS.SET_SCHEDULES, payload });
  };

  const setLoading = payload => {
    dispatch({ type: ACTIONS.SET_LOADING, payload });
  };

  const setError = payload => {
    dispatch({ type: ACTIONS.SET_ERROR, payload });
  };

  const toggleDrawer = payload => {
    dispatch({ type: ACTIONS.TOGGLE_DRAWER, payload });
  };

  const value = useMemo(
    () => ({
      orgId,
      selectedSchedule: state.selectedSchedule,
      setSelectedSchedule,
      infoSchedule: state.infoSchedule,
      setInfoSchedule,
      members: state.members,
      setMembers,
      supervisors: state.supervisors,
      setSupervisors,
      drawerState: state.drawerState,
      toggleDrawer,
      schedules: state.schedules,
      setSchedules,
      loading: state.loading,
      setLoading,
      error: state.error,
      setError,
    }),
    [orgId, state], // eslint-disable-line react-hooks/exhaustive-deps
  );

  return <ScheduleListContext.Provider value={value}>{children}</ScheduleListContext.Provider>;
};

export const useScheduleListContext = () => {
  const context = useContext(ScheduleListContext);
  const msg = 'useScheduleListContext debe ser usado dentro de un ScheduleListProvider';

  if (!context) throw new Error(msg);
  return context;
};
